import { ThinUploadModal } from "./ThinUploadModal";

export function UploadBillModal({
  open, onOpenChange,
}: { open: boolean; onOpenChange: (v: boolean) => void }) {
  return (
    <ThinUploadModal
      open={open}
      onOpenChange={onOpenChange}
      title="Vendor Invoice"
      entityType="ap_invoice"
      extractEndpoint="/ap-invoices/extract"
      detailRoutePrefix="/ap-invoices"
    />
  );
}
